// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentDetailType_container__gU5AX","price":"PaymentDetailType_price__rBuLM","title":"PaymentDetailType_title__xkz8e"};